{
  "title": "Tableau de bord de la collecte",
  "subtitle": "Chaque exécution de collecte : le résultat de chaque site et les annonces trouvées.",
  "back": "Toutes les exécutions",
  "status": {
    "completed": "Terminée",
    "partial": "Partielle",
    "failed": "Échec",
    "running": "En cours",
    "success": "Succès",
    "blocked": "Bloqué",
    "pending": "En attente",
    "not_run": "Non exécuté"
  },
  "scrapers": {
    "immobilier_ch": "Immobilier.ch",
    "homegate_ch": "Homegate.ch",
    "comparis_immobilier": "Comparis",
    "properstar_ch": "Properstar.ch",
    "anibis_ch": "Anibis.ch",
    "immoscout24_ch": "ImmoScout24.ch",
    "newhome_ch": "Newhome.ch"
  },
  "trigger": {
    "scheduled": "Planifiée",
    "manual": "Manuelle"
  },
  "singleScraper": "Un seul site : {{name}}",
  "singleScraperBanner": "Seul {{name}} a été exécuté lors de cette exécution ; les autres sites n'ont pas été lancés.",
  "noBreakdown": "Pas de détail pour cette exécution",
  "list": {
    "filters": {
      "status": "Statut",
      "scraper": "Site",
      "scope": "Portée",
      "all": "Tous",
      "fullRuns": "Tous les sites",
      "singleRuns": "Un seul site"
    },
    "empty": "Aucune exécution de collecte pour le moment",
    "columns": {
      "run": "Exécution",
      "started": "Début",
      "status": "Statut",
      "scrapers": "Sites",
      "site": "Sur le site",
      "parsed": "Lues",
      "filtered": "Filtrées",
      "imported": "Importées",
      "updated": "Mises à jour",
      "unchanged": "Inchangées",
      "merged": "Fusionnées",
      "duration": "Durée"
    }
  },
  "detail": {
    "title": "Exécution n°{{id}}",
    "started": "Début : {{date}}",
    "invalidRun": "Identifiant d'exécution invalide",
    "viewRunLog": "Journaux de l'exécution",
    "runError": "Erreur de l'exécution",
    "legacy": "Cette exécution est antérieure au détail par site : seuls les totaux sont disponibles."
  },
  "summary": {
    "siteReported": "Sur le site",
    "parsed": "Lues",
    "dropped": "Écartées",
    "filteredOut": "Filtrées",
    "imported": "Importées",
    "updated": "Mises à jour",
    "unchanged": "Inchangées",
    "merged": "Fusionnées",
    "failed": "En échec",
    "duration": "Durée totale"
  },
  "breakdown": {
    "title": "Sites",
    "viewLog": "Journaux",
    "columns": {
      "scraper": "Site",
      "status": "Statut",
      "site": "Sur le site",
      "parsed": "Lues",
      "dropped": "Écartées",
      "filtered": "Filtrées",
      "returned": "Retenues",
      "imported": "Importées",
      "updated": "Mises à jour",
      "unchanged": "Inchangées",
      "merged": "Fusionnées",
      "retired": "Retirées",
      "failed": "En échec",
      "duration": "Durée",
      "perAd": "Par annonce",
      "error": "Erreur"
    }
  },
  "ads": {
    "title": "Annonces",
    "scraper": "Site",
    "allScrapers": "Tous les sites",
    "outcomes": {
      "imported": "Importées",
      "updated": "Mises à jour",
      "unchanged": "Inchangées",
      "merged": "Fusionnées",
      "filtered_out": "Filtrées",
      "dropped": "Écartées",
      "failed": "En échec"
    },
    "columns": {
      "title": "Annonce",
      "scraper": "Site",
      "price": "Prix",
      "rooms": "Pièces",
      "size": "Surface",
      "details": "Détails",
      "time": "Temps",
      "links": "Liens"
    },
    "untitled": "Annonce sans titre",
    "empty": "Aucune annonce dans cette catégorie",
    "openInApp": "Ouvrir dans l'application",
    "openOnSite": "Ouvrir sur le site",
    "mergedInto": "Fusionnée avec l'annonce n°{{id}}",
    "viewLog": "Journaux",
    "timeTooltip": "Page de détail {{scrape}}, import {{import}}"
  },
  "logs": {
    "runTitle": "Journaux de l'exécution n°{{id}}",
    "scraperTitle": "Exécution n°{{id}} : journaux de {{name}}",
    "itemTitle": "Exécution n°{{id}} : journaux de l'annonce"
  }
}
